/*
  lg  >= 992
  xl  >= 1200
  xxl >= 1600
*/

export const gridContainer = {
  xs: { span: 24, offset: 0, order: 0 },
  sm: { span: 12, offset: 0, order: 0 },
  md: { span: 12, offset: 0, order: 0 },
  lg: { span: 12, offset: 0, order: 0 },
  xl: { span: 12, offset: 0, order: 0 },
  xxl: { span: 12, offset: 0, order: 0 },
}